import { motion } from "framer-motion";

const STORY_BG = "https://static.prod-images.emergentagent.com/jobs/4a0ea250-f6fc-48ff-a7d5-e3a33fb3e392/images/6d37099962c0a34aede7f5d11373b55cae8abc021168de1439b70021fdeed47a.png";

const ease = [0.16, 1, 0.3, 1];

export default function StorySection() {
  return (
    <section
      id="story-section"
      data-testid="story-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src={STORY_BG}
          alt=""
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/80 to-[#050505]/40" />
      </div>

      {/* Content grid */}
      <div className="relative z-10 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center min-h-[60vh]">
          {/* Left image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease }}
            className="md:col-span-5 relative"
          >
            <div className="relative overflow-hidden aspect-[3/4]">
              <img
                src="https://images.unsplash.com/photo-1733560175037-249f8954789b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxkYXJrJTIwY2hvY29sYXRlJTIwbHV4dXJ5JTIwcHJlbWl1bSUyMGFydGlzYW58ZW58MHx8fHwxNzc2MTc2Mzg3fDA&ixlib=rb-4.1.0&q=85"
                alt="Artisan chocolate crafting"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-[#050505]/30" />
              {/* Gold accent line */}
              <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-[#C6A96B] to-transparent" />
            </div>
          </motion.div>

          {/* Text block */}
          <div className="md:col-span-6 md:col-start-7">
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease }}
              className="font-body text-xs md:text-sm uppercase tracking-[0.2em] text-[#C6A96B] mb-8"
            >
              Our Story
            </motion.p>

            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1.2, delay: 0.2, ease }}
              className="font-heading text-4xl md:text-5xl font-light tracking-tight text-[#FDFBF7] mb-8"
            >
              Yin & Yang
            </motion.h2>

            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: 60 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.4, ease }}
              className="h-px bg-[#C6A96B] mb-10"
            />

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.6, ease }}
              className="font-body text-base md:text-lg font-light text-[#A3A3A3] leading-relaxed mb-8"
            >
              Chocolate was never meant to be eaten alone. At YY Atelier, every creation
              exists in two — contrasting flavours, one story, always together.
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.8, ease }}
              className="font-body text-base md:text-lg font-light text-[#A3A3A3] leading-relaxed mb-8"
            >
              Like yin and yang, each pair is two opposing forces that only find their
              meaning in each other — dark and light, fire and frost, intensity and
              delicacy. Hand-tempered from single-origin cacao across opposite hemispheres,
              each duo is crafted to be as inevitable as it is indulgent.
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 1, ease }}
              className="font-heading text-xl md:text-2xl font-light italic text-[#FDFBF7]/70 leading-relaxed mb-12"
            >
              Because at YY Atelier, contrast is not opposition — it is completion.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 1, ease }}
              className="flex items-center gap-6"
            >
              <div className="w-12 h-px bg-[#C6A96B]" />
              <span className="font-heading text-lg italic text-[#C6A96B] font-light">
                Est. 2024
              </span>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
